import bs58check from 'bs58check';
export const serializeBytes = (buffer, encoding = 'base64') => {
    if (encoding === 'base58check') {
        return bs58check.encode(buffer);
    }
    return Buffer.from(buffer).toString(encoding);
};
export const deserializeToBytes = (serializedInput, encoding = 'base64') => {
    return new Uint8Array(Buffer.from(serializedInput, encoding));
};
